import { Ban, CheckCircle2, ChevronLeft, ChevronRight, Lock } from "lucide-react";

import { Button } from "components/ui/button";

import type { MonthStats } from "../types";
import { StatBadge } from "./stat-badge";

interface YearNavigatorProps {
  selectedYear: number;
  stats: MonthStats;
  onPrev: () => void;
  onNext: () => void;
}

export function YearNavigator({
  selectedYear,
  stats,
  onPrev,
  onNext,
}: YearNavigatorProps) {
  return (
    <div className="flex flex-col md:flex-row md:items-center justify-between gap-4 bg-muted/50 p-6 rounded-lg border">
      <div className="flex items-center gap-4">
        <h2 className="text-2xl font-bold tracking-tight">{selectedYear}</h2>
        <div className="flex gap-1">
          <Button
            variant="ghost"
            size="icon"
            onClick={onPrev}
            aria-label="Ano anterior"
          >
            <ChevronLeft className="h-5 w-5" />
          </Button>
          <Button
            variant="ghost"
            size="icon"
            onClick={onNext}
            aria-label="Próximo ano"
          >
            <ChevronRight className="h-5 w-5" />
          </Button>
        </div>
      </div>

      <div className="flex flex-wrap gap-2">
        <StatBadge
          icon={<CheckCircle2 className="h-3.5 w-3.5" />}
          count={stats.released}
          label="Liberados"
          className="bg-green-100 text-green-800"
        />
        <StatBadge
          icon={<Ban className="h-3.5 w-3.5" />}
          count={stats.blocked}
          label="Bloqueados"
          className="bg-red-100 text-red-800"
        />
        <StatBadge
          icon={<Lock className="h-3.5 w-3.5" />}
          count={stats.closed}
          label="Fechados"
          className="bg-blue-100 text-blue-800"
        />
      </div>
    </div>
  );
}
